import ContentLoader from 'react-content-loader';

import { DEFAULT_SETTINGS } from '@web/consts/skeletonSettings';

export const EditorSkeleton = () => (
  <ContentLoader
    width={640}
    height={80}
    uniqueKey="conversation-skeleton-editor"
    viewBox="0 0 640 75"
    {...DEFAULT_SETTINGS}>
    <rect x="0" y="0" rx="0" ry="0" width="640" height="2" />
    <rect x="0" y="73" rx="0" ry="0" width="640" height="2" />
    <rect x="0" y="0" rx="0" ry="0" width="2" height="75" />
    <rect x="638" y="0" rx="0" ry="0" width="2" height="75" />

    <rect x="528" y="44" rx="0" ry="0" width="100" height="24" />
  </ContentLoader>
);
